<dw-container [options]="finalContainerOptions" *ngIf="chartPreferences">
    <div header>
        {{chartPreferences?.containerTitle}}

        <div class="pull-right" *ngIf="chartPreferences.gridPreferences?.showGrid && !hideToggle">
            <i class="fa fa-table mr-2" title="See table" [hidden]="!showChart" (click)="toggleShowChart()"></i>
            <i class="fa fa-chart-bar mr-1" title="See chart" [hidden]="showChart" (click)="toggleShowChart()"></i>
        </div>
    </div>
    <div body class="inner-container">
        <div *ngIf="data?.length==0" class="tile-no-data-container">
            <div class="no-data-label">No Data</div>
        </div>
        <ng-container *ngIf="data?.length>0">

            <div class="chart-container" *ngIf="chartConfig && showChart">
                <p-chart [type]="chartConfig?.chartType" [data]="chartConfig?.chartData" [query]="query"
                    [options]="chartConfig?.chartOptions" (onDataSelect)="onDataSelect($event)"></p-chart>
            </div>
            <div *ngIf="!showChart && !chartPreferences.gridPreferences?.useChartDataForGrid">
                <dw-quick-grid [item]="query.RootTable" [query]="query" [columnPreferences]="columnPreferences" [useFlexColumns]="true" ConfigKeyPart="chart-data"
                    [loadCount]="loadCount" [customizeActions]="true" (gridEvent)="onGridEvent($event)" [allowConfiguration]="true"></dw-quick-grid>
            </div>
            <div *ngIf="!showChart && chartPreferences.gridPreferences?.useChartDataForGrid" class="chart-data-grid-container">
                <table class="table table-sm table-striped">
                    <thead>
                        <tr>
                            <th *ngFor="let column of columnPreferences">{{column.label || column.field}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let row of data">
                            <td *ngFor="let column of columnPreferences">{{row[column.field]}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="additional-text">{{additionalText}}</div>

            <ng-content>

            </ng-content>
        </ng-container>
    </div>
</dw-container>
